import React from 'react'
import injectStyles from 'react-jss'
import { theme } from 'Assets/Styles/theme'

const styles = {
  cancelButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: `1px solid ${theme.colors.primary}`,
    color: theme.colors.primary,
    backgroundColor: '#FFFFFF',
    padding: '8px 16px',
    // maxWidth: '86px',
    fontWeight: 700,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.colors.primary}`,
      color: '#FFFFFF',
      backgroundColor: `${theme.colors.primary}`,
    },
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: `1px solid ${theme.colors.primary}`,
    color: '#FFFFFF',
    padding: '8px 16px',
    backgroundColor: `${theme.colors.primary}`,
    // maxWidth: '86px',
    fontWeight: 700,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'pointer',
    '&:hover': {
      border: `1px solid ${theme.colors.primary}`,
      color: theme.colors.primary,
      backgroundColor: '#FFFFFF',
    },
  },
  disabledButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '4px',
    border: '1px solid rgba(0, 0, 0, 0.12)',
    color: 'rgba(0, 0, 0, 0.26)',
    padding: '8px 16px',
    backgroundColor: 'rgba(0, 0, 0, 0.12)',
    // maxWidth: '86px',
    fontWeight: 700,
    fontFamily: '"Roboto Regular",Helvetica,Arial,sans-serif',
    fontSize: '14px',
    lineHeight: '20px',
    cursor: 'not-allowed',
  },
}

const Button = ({
  label,
  onClick = () => {},
  disabled = false,
  outlined = true,
  classes,
  styles = {},
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={
        disabled
          ? classes.disabledButton
          : outlined
          ? classes.actionButton
          : classes.cancelButton
      }
      style={styles}
    >
      {label}
    </button>
  )
}

export default injectStyles(styles)(Button)
